module.exports = __webpack_public_path__ + "img/Dia_de_los_muertos.c660c37.jpg";